import React from 'react';
import { certifications } from '../mockData';
import { Award, Shield, CheckCircle2 } from 'lucide-react';

const Certifications = () => {
  return (
    <section id="certifications" className="certifications-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Quality Assurance</span>
          <h2 className="section-title">Certifications & Standards</h2>
          <p className="section-description">
            Committed to international standards in quality, environment, and safety
          </p>
        </div>

        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <div 
              key={cert.id} 
              className="cert-card"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="cert-icon-wrapper">
                {index === 0 && <Award className="cert-icon" />}
                {index === 1 && <Shield className="cert-icon" />}
                {index === 2 && <CheckCircle2 className="cert-icon" />}
                {index === 3 && <Award className="cert-icon" />}
              </div>
              
              <div className="cert-content">
                <h3 className="cert-title">{cert.title}</h3>
                <p className="cert-description">{cert.description}</p>
                <div className="cert-details">
                  <span className="cert-number">Certificate No: {cert.certificateNo}</span>
                </div>
              </div>
              
              <div className="cert-badge">
                <CheckCircle2 className="w-5 h-5" />
                Certified
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
